import { render, staticRenderFns } from "./course_list.vue?vue&type=template&id=70bd6ec6&scoped=true"
import script from "./course_list.vue?vue&type=script&lang=js"
export * from "./course_list.vue?vue&type=script&lang=js"
import style0 from "./course_list.vue?vue&type=style&index=0&id=70bd6ec6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bd6ec6",
  null
  
)

export default component.exports